import React, { useState } from "react";
import { BasicNotificationBanner } from "../BasicNotificationBanner";
import { ActionButton } from "../ActionButton";

export interface CloseableNotificationBannerProps {
  title?: string;
  message: string | (() => void);
  variant: NotificationBannerVariant;
  icon: NotificationBannerIcon;
  actionButton?: React.ReactNode;
  visible: boolean;
}

export const CloseableNotificationBanner: React.FC<CloseableNotificationBannerProps> =
  ({ title, message, variant, icon, actionButton, visible }) => {
    const [show, setShow] = useState<boolean>(visible);

    const handleClick = () => setShow((prevState) => !prevState);

    return show ? (
      <BasicNotificationBanner
        title={title}
        message={message}
        variant={variant}
        icon={icon}
        actionButton={actionButton}
        closeButton={
          <ActionButton
            icon="close"
            variant="transparent"
            color="neutrals.dn40"
            onClick={handleClick}
            ml="auto"
          />
        }
      />
    ) : null;
  };

CloseableNotificationBanner.defaultProps = {
  visible: true,
};
